function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash';
// eslint-disable-next-line import/no-cycle,import/no-unresolved
import { getProductWeight } from 'shared/helpers/products';
// eslint-disable-next-line import/no-cycle
import { matchesBrand, matchesCategory, matchesInventoryTag, matchesProductId, matchesProductTag, matchesStrain, matchesVendor } from 'shared/order/bogo/common';
/* **************************
 * A set of helpers specifically for 3.5 specials
 *************************** */ // Accepts a product, a set of restrictions (bogoConditions, bogoRewards, saleDiscounts), and a special object
// Returns an object with a boolean for whether any option was found, along with the eligible set per restriction
export function checkProductForEligibleOptions() {
    var product = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, restrictions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], special = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var eligibleProductOptionsPerRestriction = _.map(restrictions, function(restriction) {
        return eligibleProductOptionsForRestriction(product, restriction, 'inclusion', special);
    });
    var productHasEligibleOption = false;
    _.forEach(eligibleProductOptionsPerRestriction, function(options) {
        if (options.length > 0) {
            productHasEligibleOption = true;
            return false;
        }
        return true;
    });
    return {
        productHasEligibleOption: productHasEligibleOption,
        eligibleProductOptionsPerRestriction: eligibleProductOptionsPerRestriction
    };
}
// Accepts a special. Returns true or false depending on if the special is v3.5
export function isSpecialVersion3dot5() {
    var special = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (special === null || special === void 0 ? void 0 : special.version) === 3 && (special === null || special === void 0 ? void 0 : special.minorVersion) === 5 || // TODO: remove this once minorVersion is being added by Arma discountSync as 5
    isArmageddonDiscountSyncSpecial(special);
}
// Accepts a special. Returns true or false depending on if the special is created or updated by discount sync v2
export function isArmageddonDiscountSyncSpecial() {
    var special = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (special === null || special === void 0 ? void 0 : special.createdBy) === 'ArmageddonDiscountSync' || (special === null || special === void 0 ? void 0 : special.updatedBy) === 'ArmageddonDiscountSync';
}
// Accepts a product, a restriction object (bogoCondition, bogoRewards, saleDiscount, or an exclusion),
//    a restrictionType ('inclusion' or 'exclusion'), and a special object
// Returns an array of all eligible product options (weights) for that restriction
export function eligibleProductOptionsForRestriction() {
    var product = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, restriction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, restrictionType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'inclusion', special = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var _restriction_productIds;
    // Guard against null restrictions (default param only covers undefined)
    if (!restriction) {
        return [];
    }
    // Totally skip the restriction if 'IGNORE' is present
    if (((_restriction_productIds = restriction.productIds) === null || _restriction_productIds === void 0 ? void 0 : _restriction_productIds[0]) === 'IGNORE') {
        return [];
    }
    return eligibleProductOptionsV2(product, restriction, restrictionType, special);
}
/* ******************************************
 * Implementation helpers
 ****************************************** */ function eligibleProductOptionsV2(product, restriction, restrictionType, special) {
    // For exclusions, just find matching options
    if (restrictionType === 'exclusion') {
        return findMatchingOptionsV2(product, restriction, special);
    }
    // For inclusions, find eligible options then subtract exclusions
    var baseOptions = findMatchingOptionsV2(product, restriction, special);
    // Handle nested exclusions
    if (!_.isEmpty(restriction.exclusions)) {
        var excludedOptions = findExcludedOptionsV2(product, restriction.exclusions, special);
        return _.difference(baseOptions, excludedOptions);
    }
    return baseOptions;
}
// Find all options that match the restriction criteria
function findMatchingOptionsV2(product, restriction, special) {
    var matchOperator = getMatchOperator(restriction, 'inclusion');
    // Check if product matches non-weight criteria
    var _matchesRestriction = matchesRestriction(product, matchOperator === 'or' && (special === null || special === void 0 ? void 0 : special.directPOSProductIdMapping) ? _object_spread_props(_object_spread({}, restriction), {
        productIds: []
    }) : restriction, 'inclusion'), productMatches = _matchesRestriction.isMatch, isNonProductIdMatch = _matchesRestriction.isNonProductIdMatch;
    if (!productMatches && matchOperator === 'and') {
        return [];
    }
    // Get weight-filtered options (this is where bug fixes live)
    return getWeightFilteredOptionsV2(product, restriction, matchOperator, special, productMatches, isNonProductIdMatch);
}
// Process nested exclusions (non-recursive, just maps)
function findExcludedOptionsV2(product, exclusions, special) {
    var _$_;
    return (_$_ = _).union.apply(_$_, _to_consumable_array(exclusions.map(function(exclusion) {
        return findMatchingOptionsV2(product, exclusion, special);
    })));
}
// Get options filtered by weight criteria with bug fixes
function getWeightFilteredOptionsV2(product, restriction, matchOperator, special, productMatches, isNonProductIdMatch) {
    var eligibleOptions = [];
    // For 'or' cases, get weight options upfront
    if (matchOperator === 'or') {
        eligibleOptions = getMatchingWeightOptionsV2(product, restriction, true, matchOperator, special);
    }
    // If product matches, get the appropriate weight options.
    // eligibleOptions may be an object { filteredOptions, filteredRawOptions } when
    // getMatchingWeightOptionsV2 returns activeBatchTag results, so check both shapes.
    var hasInitialOptions = _.isArray(eligibleOptions) ? eligibleOptions.length > 0 : !_.isEmpty(eligibleOptions === null || eligibleOptions === void 0 ? void 0 : eligibleOptions.filteredOptions);
    if (productMatches || hasInitialOptions) {
        if (matchOperator === 'and') {
            eligibleOptions = getMatchingWeightOptionsV2(product, restriction, false, matchOperator, special);
        } else if (productMatches) {
            var _restriction_productIds, _restriction_inventoryTags;
            // For 'or' cases with a match, get all weight options
            var adjustedRestriction = {
                productIds: (_restriction_productIds = restriction === null || restriction === void 0 ? void 0 : restriction.productIds) !== null && _restriction_productIds !== void 0 ? _restriction_productIds : [],
                weights: [],
                inventoryTags: (_restriction_inventoryTags = restriction === null || restriction === void 0 ? void 0 : restriction.inventoryTags) !== null && _restriction_inventoryTags !== void 0 ? _restriction_inventoryTags : []
            };
            if (isNonProductIdMatch && (special === null || special === void 0 ? void 0 : special.directPOSProductIdMapping)) {
                adjustedRestriction.productIds = [];
            }
            eligibleOptions = getMatchingWeightOptionsV2(product, adjustedRestriction, false, matchOperator, special);
        }
        // Handle activeBatchTags format
        if (!_.isArray(eligibleOptions)) {
            eligibleOptions = _.uniq(_to_consumable_array(eligibleOptions.filteredOptions).concat(_to_consumable_array(eligibleOptions.filteredRawOptions)));
        }
        return eligibleOptions;
    }
    return [];
}
function getMatchingWeightOptionsV2(product, restriction, returnEmptyIfNoCriteria, matchOperator, special) {
    var _restriction_weights = restriction.weights, weights = _restriction_weights === void 0 ? [] : _restriction_weights, _restriction_weightOperator = restriction.weightOperator, weightOperator = _restriction_weightOperator === void 0 ? 'equalTo' : _restriction_weightOperator;
    var weightConstraints = _.compact(weights);
    var _restriction_inventoryTags;
    var activeBatchTagsConstraints = (_restriction_inventoryTags = restriction.inventoryTags) !== null && _restriction_inventoryTags !== void 0 ? _restriction_inventoryTags : [];
    var productOptions = [];
    var rawProductOptions = [];
    // Get product options
    if (!_.isEmpty(product.Options)) {
        productOptions = _to_consumable_array(product.Options);
    } else if (product.option) {
        productOptions.push(product.option);
    }
    if (special === null || special === void 0 ? void 0 : special.rawPOSWeightMapping) {
        if (!_.isEmpty(product.rawOptions)) {
            rawProductOptions = _to_consumable_array(product.rawOptions);
        } else if (product.rawOption) {
            rawProductOptions.push(product.rawOption);
        }
    }
    // Snapshot before inventory-tag filtering narrows productOptions, so the final
    // productId intersection at the bottom operates on all options, not just those
    // that happened to have a matching inventory tag.
    var allProductOptions = _to_consumable_array(productOptions);
    if ((_.isEmpty(weightConstraints) || _.includes(weightConstraints, 'Any Weight')) && _.isEmpty(activeBatchTagsConstraints)) {
        var optionsWhenNoCriteria = returnEmptyIfNoCriteria ? [] : productOptions;
        if ((special === null || special === void 0 ? void 0 : special.directPOSProductIdMapping) && !_.isEmpty(restriction.productIds)) {
            return getOptionsFromPOSProductIds(product, optionsWhenNoCriteria, restriction, special);
        }
        return optionsWhenNoCriteria;
    }
    // Filter by activeBatchTags if present
    if (!_.isEmpty(activeBatchTagsConstraints)) {
        var _getOptionsFromActiveBatchTags = getOptionsFromActiveBatchTags(product, productOptions, rawProductOptions, restriction), filteredOptions = _getOptionsFromActiveBatchTags.filteredOptions, filteredRawOptions = _getOptionsFromActiveBatchTags.filteredRawOptions;
        if (_.isEmpty(weightConstraints)) {
            // When productIds are also present, combine with inventory tag results using the
            // match operator so that exclusions with both criteria types work as OR.
            if (!_.isEmpty(restriction.productIds)) {
                // An 'and' intersection with an empty tag-match result is always empty --
                // skip the productId lookup rather than paying for it on every product.
                if (matchOperator === 'and' && _.isEmpty(filteredOptions)) {
                    return {
                        filteredOptions: [],
                        filteredRawOptions: filteredRawOptions
                    };
                }
                var posFilteredOptions = getOptionsFromPOSProductIds(product, productOptions, restriction);
                var combinedOptions = matchOperator === 'or' ? _.union(filteredOptions, posFilteredOptions) : _.intersection(filteredOptions, posFilteredOptions);
                return {
                    filteredOptions: combinedOptions,
                    filteredRawOptions: filteredRawOptions
                };
            }
            return {
                filteredOptions: filteredOptions,
                filteredRawOptions: filteredRawOptions
            };
        }
        productOptions = filteredOptions;
        rawProductOptions = filteredRawOptions;
    }
    // Filter by weight criteria
    var checkEqualTo = _.isNil(weightOperator) || weightOperator === 'equalTo' || weightOperator === 'greaterThanEqualTo';
    var checkGreaterThan = weightOperator === 'greaterThan' || weightOperator === 'greaterThanEqualTo';
    var weightConstraintsInGrams = _.map(weightConstraints, function(constraint) {
        return getProductWeight(constraint);
    });
    var weightFilteredOptions = _.reduce(productOptions, function(matchingProductOptions, productOption, optionIndex) {
        var productOptionInGrams = getProductWeight(productOption);
        var _rawProductOptions_optionIndex;
        var rawProductOption = (_rawProductOptions_optionIndex = rawProductOptions[optionIndex]) !== null && _rawProductOptions_optionIndex !== void 0 ? _rawProductOptions_optionIndex : null;
        var rawProductOptionInGrams = rawProductOption ? getProductWeight(rawProductOptions[optionIndex]) : null;
        _.forEach(weightConstraintsInGrams, function(weightConstraintInGrams, index) {
            if (checkEqualTo && (productOption === weightConstraints[index] || productOptionInGrams === weightConstraintInGrams || rawProductOption === weightConstraints[index] || rawProductOptionInGrams === weightConstraintInGrams || weightConstraints[index] === 'Any Weight')) {
                matchingProductOptions.push(productOption);
                return false;
            }
            if (checkGreaterThan && (productOptionInGrams > weightConstraintInGrams || rawProductOptionInGrams > weightConstraintInGrams)) {
                matchingProductOptions.push(productOption);
                return false;
            }
            return true;
        });
        return matchingProductOptions;
    }, []);
    if ((special === null || special === void 0 ? void 0 : special.directPOSProductIdMapping) && !_.isEmpty(restriction.productIds)) {
        var posProductIdFilteredOptions = getOptionsFromPOSProductIds(product, productOptions, restriction, special);
        var combinedFilteredOptions = matchOperator === 'or' ? _.union(posProductIdFilteredOptions, weightFilteredOptions) : _.intersection(posProductIdFilteredOptions, weightFilteredOptions);
        // Use allProductOptions (pre-inventory-tag-filter) so a productId match is not
        // silently dropped when the child has no matching inventory tag.
        return _.intersection(allProductOptions, combinedFilteredOptions);
    }
    return weightFilteredOptions;
}
// Accepts a product, restriction (bogoCondition, bogoReward, saleDiscount, or an exclusion), and a restrictionType (inclusion or exclusion)
// Returns an object with booleans indicating whether the product matches restriction criteria on productIds or non-productIds fields
function matchesRestriction() {
    var product = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, restriction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, restrictionType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'inclusion';
    if (restriction.productGroup === 'all') {
        return {
            isMatch: true,
            isNonProductIdMatch: true
        };
    }
    var matchOperator = getMatchOperator(restriction, restrictionType);
    // For 'or' cases, we should only be returning true if criteria is present and a match
    // For 'and' cases, if criteria is not present it is still considered a match
    var failIfNoCriteria = matchOperator === 'or';
    if (matchOperator === 'or') {
        if (matchesBrand(restriction, product, 'brand', failIfNoCriteria) || matchesCategory(restriction, product, 'category', failIfNoCriteria) || matchesStrain(restriction, product, failIfNoCriteria) || matchesVendor(restriction, product, failIfNoCriteria) || matchesInventoryTag(restriction, product, failIfNoCriteria) || matchesProductTag(restriction, product, failIfNoCriteria)) {
            return {
                isMatch: true,
                isNonProductIdMatch: true
            };
        }
        if (matchesProductId(restriction, product, failIfNoCriteria)) {
            return {
                isMatch: true,
                isNonProductIdMatch: false
            };
        }
        return {
            isMatch: false,
            isNonProductIdMatch: false
        };
    }
    var brandMatch = matchesBrand(restriction, product, 'brand', failIfNoCriteria);
    var categoryMatch = matchesCategory(restriction, product, 'category', failIfNoCriteria);
    var productMatch = matchesProductId(restriction, product, failIfNoCriteria);
    var strainMatch = matchesStrain(restriction, product, failIfNoCriteria);
    var vendorMatch = matchesVendor(restriction, product, failIfNoCriteria);
    var productTagMatch = matchesProductTag(restriction, product, failIfNoCriteria);
    var inventoryTagMatch = matchesInventoryTag(restriction, product, failIfNoCriteria);
    var nonProductMatch = brandMatch && categoryMatch && strainMatch && vendorMatch && productTagMatch && inventoryTagMatch;
    return {
        isMatch: productMatch && nonProductMatch,
        isNonProductIdMatch: nonProductMatch
    };
}
// Accepts a product restriction object (bogoCondition, bogoReward, saleDiscount, or an exclusion) and a restrictionType (inclusion or exclusion)
// Returns the matchOperator designating logic between product group restrictions ("and" or "or")
function getMatchOperator() {
    var restriction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, restrictionType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'inclusion';
    var defaultMatchOperator = restrictionType === 'inclusion' ? 'and' : 'or';
    return (restriction === null || restriction === void 0 ? void 0 : restriction.matchOperator) ? restriction.matchOperator : defaultMatchOperator;
}
// The same restriction.productIds array is reused across every product in a serializer pass
// (thousands of products x hundreds of specials), so the lookup Set is cached per array
// reference rather than rebuilt on every call. WeakMap keys are GC'd once the restriction/special
// data they came from is no longer referenced, so this can't leak across requests.
var productCriteriaSetCache = new WeakMap();
function getProductCriteriaSet(productCriteria) {
    var set = productCriteriaSetCache.get(productCriteria);
    if (!set) {
        set = new Set(productCriteria);
        productCriteriaSetCache.set(productCriteria, set);
    }
    return set;
}
// Accepts a product, set of productOptions, and restriction object
// Returns either the set of options applicable for this product based on child canonicalIDs and restriction criteria
//    or the productOptions unaltered if no productIds are present on the restriction
function getOptionsFromPOSProductIds() {
    var product = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], restriction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _product_POSMetaData;
    var _restriction_productIds;
    var productCriteria = (_restriction_productIds = restriction.productIds) !== null && _restriction_productIds !== void 0 ? _restriction_productIds : [];
    if (_.isEmpty(productCriteria)) {
        return productOptions;
    }
    var productCriteriaSet = getProductCriteriaSet(productCriteria);
    return _.reduce((_product_POSMetaData = product.POSMetaData) === null || _product_POSMetaData === void 0 ? void 0 : _product_POSMetaData.children, function(options, child) {
        if (productCriteriaSet.has(child === null || child === void 0 ? void 0 : child.canonicalID)) {
            options.push(child.option);
        }
        return options;
    }, []);
}
function getOptionsFromActiveBatchTags() {
    var product = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], rawOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], restriction = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var _restriction_inventoryTags;
    var qualifiedTags = _to_consumable_array((_restriction_inventoryTags = restriction.inventoryTags) !== null && _restriction_inventoryTags !== void 0 ? _restriction_inventoryTags : []);
    if (_.isEmpty(qualifiedTags)) {
        return {
            productOptions: productOptions,
            rawOptions: rawOptions
        };
    }
    var filterOptions = function(options, getOptionValue) {
        return _.reduce(options, function(filteredOptions, option) {
            var _product_POSMetaData_children, _product_POSMetaData, _childProduct_activeBatchTags;
            var childProduct = (_product_POSMetaData = product.POSMetaData) === null || _product_POSMetaData === void 0 ? void 0 : (_product_POSMetaData_children = _product_POSMetaData.children) === null || _product_POSMetaData_children === void 0 ? void 0 : _product_POSMetaData_children.find(function(child) {
                return child.option === getOptionValue(option);
            });
            var childTags = childProduct === null || childProduct === void 0 ? void 0 : (_childProduct_activeBatchTags = childProduct.activeBatchTags) === null || _childProduct_activeBatchTags === void 0 ? void 0 : _childProduct_activeBatchTags.map(function(tag) {
                return tag.tagId;
            });
            if (_.intersection(qualifiedTags, childTags).length > 0) {
                filteredOptions.push(option);
            }
            return filteredOptions;
        }, []);
    };
    var filteredOptions = filterOptions(productOptions, function(option) {
        return option;
    });
    var filteredRawOptions = filterOptions(rawOptions, getProductWeight);
    return {
        filteredOptions: filteredOptions,
        filteredRawOptions: filteredRawOptions
    };
}
